import { useEffect, useState } from "react";
import api from "../lib/api";

export const ClientChecklist = ({ clientId }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/clients/${clientId}/checklist`).then((r) => setData(r.data)).catch(() => {});
  }, [clientId]);

  if (!data) return null;

  const Col = ({ title, owner, done, total, tid }) => (
    <div className="rounded-lg border border-stone-200 bg-white p-4" data-testid={tid}>
      <p className="text-xs font-semibold uppercase tracking-wide text-stone-500">
        {title} <span className={done === total ? "text-[#1e8449]" : "text-[#8a5d14]"}>({done}/{total})</span>
      </p>
      <div className="mt-2 space-y-1.5">
        {data.items.filter((i) => i.owner === owner).map((i) => (
          <p key={i.key} className="flex items-center gap-2 text-sm" data-testid={`checklist-${i.key}`}>
            {i.done
              ? <span className="flex h-4 w-4 items-center justify-center rounded-full bg-[#27AE60]/15 text-[10px] font-bold text-[#1e8449]">✓</span>
              : <span className="h-4 w-4 rounded-full border border-stone-300" />}
            <span className={i.done ? "text-stone-700" : "text-stone-400"}>{i.label}{i.detail ? ` — ${i.detail}` : ""}</span>
          </p>
        ))}
      </div>
    </div>
  );

  return (
    <div className="mb-6" data-testid="client-checklist">
      <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
        <p className="font-heading text-sm font-semibold text-stone-900">Intake checklist — who fills what</p>
        {data.client_email && <p className="text-xs text-stone-500" data-testid="checklist-client-email">Client email on file: <span className="font-medium">{data.client_email}</span></p>}
      </div>
      <div className="grid gap-3 md:grid-cols-2">
        <Col title="Client / family (wizard link)" owner="client" done={data.client_done} total={data.client_total} tid="checklist-client" />
        <Col title="Office" owner="office" done={data.office_done} total={data.office_total} tid="checklist-office" />
      </div>
    </div>
  );
};
